<template>
  <div class="main-bottom">
    <span class="copyright">深圳市慧智创新网络有限公司 版权所有</span>
    <span class="ui-link"></span>
  </div>
</template>

<script>
export default {
  name: "mainBottom",
};
</script>

<style>
.main-bottom {
  width: 100%;
  height: 62px;
  line-height: 62px;
  /* background-color: #2893fb; */
  background-color: #000000;
  text-align: center;
  color: #fff;
  margin-top: 15px;
}
.copyright {
  margin-right: 20px;
}
.ui-link {
  cursor: pointer;
}
</style>